/** "+0°", "+90°", "-90°": the turn that will be added to whatever rotation the page already has. */
export const fmtDelta = (a: number) => `${a < 0 ? "-" : "+"}${Math.abs(a)}°`;
